import { makeStyles, Theme } from "@material-ui/core";

export const contractStyles = makeStyles((theme: Theme) => ({
   pdfContainer: {
      height: "65vh",
      borderWidth: 1,
      borderStyle: "solid",
   },
}));
